// eslint-disable-next-line import/prefer-default-export
export const SET_EMPLOYMENT_SEARCH_QUERY = 'setEmploymentSearchQuery';
